export const locale = {
  mainSeries: 'Change main series',
  compare: 'Compare',
  compareHint: 'Compare with main series',
  compareChange: 'Change compare series',
  comparePlus: '+',
  close: 'Close tab',
  deleteCompareSeries: 'Delete series',
  timeRange: 'Change time range',
  hvTerm: 'Change HV',
  ivxTerm: 'Change Period',
  optionType: 'Change Option type',
  moneyness: 'Change Moneyness',
  date: 'Change date',
  time: 'Change time',
  totalOiChartType: 'Change type',
  firstPoint: 'Point 1',
  secondPoint: 'Point 2',
  changeIvDiffStock: 'Change Stock',
  'ivxTerm-first': 'Change Period',
  'ivxTerm-second': 'Change Period',
  'stockId-first': 'Change stock',
  'stockId-second': 'Change stock',
  'moneyness-first': 'Change Moneyness',
  'moneyness-second': 'Change Moneyness',
  expirationDate: 'Change expiration date',
  strike: 'Change strike',
  singleContractAnalyzerType: 'Change chart type'
};
